<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs
        :items="breadcrumbs"
        divider=">"
        class="pb-0 pl-1"
      />
    </v-col>

    <v-col class="pa-2" cols="12" offset-lg="1" lg="6">
      <Info />
    </v-col>

    <v-col class="pa-2" cols="12" lg="4">
      <SettingList />
    </v-col>
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import Info from "@/views/protected/company/cards/Info";
import SettingList from "@/views/protected/company/cards/Settings";

export default {
  name: Component.Protected.Company.Home,
  data: () => ({
    breadcrumbs: Breadcrumbs.Company.Home,
  }),
  components: { Info, SettingList },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.$store.dispatch(Actions.Company.Company);
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
.card--flex-toolbar {
  margin-top: -56px;
}
</style>